import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Goals = props => (
  <SvgIcon viewBox="0 0 17.697 17.638" {...props}>
    <g id="Group_2575" data-name="Group 2575" transform="translate(11.817 2.205)">
      <path id="Path_2528" data-name="Path 2528" d="M16.63,11.9a.551.551,0,0,1-.11-1.091c2.007-.409,4.135-2.879,4.323-6.706H18.41a.551.551,0,0,1,0-1.1h3a.551.551,0,0,1,.551.551c0,4.776-2.625,7.809-5.218,8.338A.574.574,0,0,1,16.63,11.9Z" transform="translate(-16.08 -3)" />
    </g>
    <g id="Group_2576" data-name="Group 2576" transform="translate(0 2.205)">
      <path id="Path_2529" data-name="Path 2529" d="M5.263,11.885a.578.578,0,0,1-.121-.013C2.587,11.3,0,8.257,0,3.551A.551.551,0,0,1,.551,3h2.94a.551.551,0,1,1,0,1.1H1.116C1.3,7.875,3.4,10.352,5.383,10.8a.551.551,0,0,1-.121,1.089Z" transform="translate(0 -3)" />
    </g>
    <g id="Group_2577" data-name="Group 2577" transform="translate(7.349 11.839)">
      <path id="Path_2530" data-name="Path 2530" d="M12.388,16.11a.551.551,0,0,0-.551.551H11.1a.551.551,0,0,0-1.1,0v2.675a.551.551,0,0,0,.551.551h1.837a.551.551,0,0,0,.551-.551V16.661A.551.551,0,0,0,12.388,16.11Z" transform="translate(-10 -16.11)" />
    </g>
    <g id="Group_2578" data-name="Group 2578" transform="translate(5.144 14.698)">
      <path id="Path_2531" data-name="Path 2531" d="M12.328,20H9.021A2.023,2.023,0,0,0,7,22.021v.367a.551.551,0,0,0,.551.551H13.8a.551.551,0,0,0,.551-.551v-.367A2.023,2.023,0,0,0,12.328,20Z" transform="translate(-7 -20)" />
    </g>
    <g id="Group_2579" data-name="Group 2579" transform="translate(2.94 0)">
      <path id="Path_2532" data-name="Path 2532" d="M14.473,0H5.286A1.288,1.288,0,0,0,4,1.286V6.618c.032,4.745,5.467,6.684,5.7,6.764a.547.547,0,0,0,.181.031.558.558,0,0,0,.18-.03c.232-.081,5.7-2.021,5.7-6.769V1.286A1.288,1.288,0,0,0,14.473,0Z" transform="translate(-4 0)" />
    </g>
  </SvgIcon>
);

export default Goals;
